/* eslint-disable no-unused-vars */
/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { Button } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { InputAdornment, TextField } from '@material-ui/core';
import Spinner from '../../../../../../SharedModules/Spinner/SpinnerNew';
import CustomSeparator from '../../../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import SVGComponent from '../../../../../../SharedModules/SVGComponents/SVGComponents';
import {
  saveCmsQtrReport,
  updateReportQuarter,
  setCreateCmsExtraState,
  dispatchSaveCmsQtrReport,
} from '../Store/actions';
import DisplaySuccessMessages from '../../../../../../SharedModules/Errors/SuccessMessage';
import { SUCCESSMESSAGE_GENERIC } from '../../../../../../SharedModules/Errors/constantMessageData';
import SaveCancelPopup from '../../../../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import { closeTab } from '../../../../../../SharedModules/CommonUtilities/commonUtilities';

const InitCorrectCmsReport = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const cmsReport = useSelector(
    (state) => state.sharedState.CreateCmsReportReducer.createCmsReport
  );
  const detailScreenObj = useSelector(
    (state) => state.sharedState.CreateCmsReportReducer?.detailScreenObj
  );
  const previousQtr = useSelector(
    (state) => state.sharedState.CreateCmsReportReducer.previousQtr || []
  );

  const saveCmsmesage = useSelector(
    (state) => state.sharedState.CreateCmsReportReducer.saveCmsQtrRpt || ''
  );
  const errorMessages = useSelector(
    (state) => state.sharedState.CreateCmsReportReducer.errorMessages
  );

  const extraState = useSelector(
    (state) => state.sharedState.CreateCmsReportReducer.extraState
  );

  const edit = useSelector(
    (state) => state.sharedState.CreateCmsReportReducer.extraState.edit
  );

  const setStateChange = (key, val) => {
    setState({
      ...extraState,
      [key]: val,
    });
  };

  // use Selector function
  const headerList =
    cmsReport?.headerList && cmsReport?.headerList?.[0]
      ? cmsReport.headerList[0]
      : {};
  const headerListRpc =
    cmsReport?.reportQtrDetailList &&
    cmsReport?.reportQtrDetailList?.[0]?.cmsQtrRptBalancePK?.rebateProgramCd;

  const [fullScreenView, setFullScreenView] = useState(false);
  const [disableBtn, setDisableBtn] = useState(true);
  const [reportQtrDetailList, setReportQtrDetailList] = useState({});
  const setState = (value) => dispatch(setCreateCmsExtraState(value));
  const localStore = JSON.parse(localStorage.getItem('tabItemsData'));
  const [successMessages, setSuccessMessages] = React.useState([]);
  const [open, setOpen] = useState(false);
  const [openCancel, setOpenCancel] = useState(false);
  const [isMounted, setIsMounted] = useState();
  const [inputField, setInputField] = useState({
    input0: false,
    input1: false,
    input2: false,
    input3: false,
    input4: false,
  });
  const reportQtr = cmsReport?.reportQtrDetailList
    ? cmsReport?.reportQtrDetailList
    : false;

  useEffect(() => {
    setSuccessMessages([]);
    const clone = JSON.parse(JSON.stringify(reportQtr));
    setReportQtrDetailList({ ...clone });
  }, [reportQtr]);

  useEffect(() => {
    return () => {
      dispatch(dispatchSaveCmsQtrReport(''));
    };
  }, []);

  // Tab highlighter POC
  React.useEffect(() => {
    const errMsg = errorMessages;
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    const newObj =
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.map((item) => {
        if (item.navTo === '/initCorrectCms64Report' && edit) {
          item.isFormDirty = true;
        } else {
          item.isFormDirty = false;
        }
        if (item.navTo === '/initCorrectCms64Report') {
          if (edit && !_.isEmpty(errMsg)) {
            item.isFormError = true;
          } else {
            item.isFormError = false;
          }
        }
        return item;
      });
    localStorage.setItem('tabItemsData', JSON.stringify(newObj));
  }, [edit, errorMessages]);

  // Close Popup POC---
  useEffect(() => {
    setIsMounted(true);
  }, []);

  useEffect(() => {
    if (isMounted) {
      const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
      if (
        updateTabs &&
        updateTabs.length > 0 &&
        updateTabs.filter((x) => {
          return x.navTo === '/initCorrectCms64Report' && x.isFormSave;
        }).length > 0
      ) {
        const newObj = updateTabs.map((item) => {
          if (item.navTo === '/initCorrectCms64Report' && item.isFormSave) {
            item.isFormSave = false;
            saveAndCloseTab();
          }
          return item;
        });
        localStorage.setItem('tabItemsData', JSON.stringify(newObj));
      }
    }
  }, [JSON.parse(localStorage.getItem('tabItemsData'))]);

  const forNegativeValues = (cellInfo) => {
    const isNegativeVal = parseFloat(cellInfo?.value?.toString() || 0) < 0;
    return (
      <>
        {isNegativeVal == true ? (
          <div
            style={{ color: '#DC143C', textAlign: 'right', marginLeft: 'auto' }}
          >{`($ ${cellInfo.value?.toString()?.replace('-', '').trim()})`}</div>
        ) : (
          <div
            style={{ color: '#000', textAlign: 'right', marginLeft: 'auto' }}
          >{`$ ${cellInfo.value}`}</div>
        )}
      </>
    );
  };

  const openSave = () => {
    setSuccessMessages([]);
    setOpen(
      (edit && _.isEmpty(errorMessages)) ||
        (edit == 'false' && errorMessages.length == 0) ||
        false
    );
  };

  function resetForm() {
    setSuccessMessages([]);
    const clone = JSON.parse(JSON.stringify(reportQtr));
    setReportQtrDetailList({ ...clone });
    setOpenCancel(false);
    setDisableBtn(true);
  }

  function geBalance(index) {
    if (
      reportQtrDetailList &&
      reportQtrDetailList[index] &&
      reportQtrDetailList[index].balanceAmt !== undefined
    ) {
      return reportQtrDetailList[index].balanceAmt;
    } else if (index >= 0 && index < 5) {
      return 0;
    }
    return cmsReport?.finalTotals || 0;
  }

  function rebateProgramCd(index) {
    return headerListRpc ? headerListRpc : '';
  }

  function reportQuarter(index) {
    return headerList.rptQtr ? headerList.rptQtr : '0';
  }

  function updatePreviousQtr(e, index) {
    setSuccessMessages([]);
    if (disableBtn) {
      setDisableBtn(false);
    }
    const obj = { ...reportQtrDetailList };
    if (!reportQtrDetailList[index]) {
      obj[index] = {};
    }
    var val = e.target.value?.replace(/\$|\(|\)/g, '');
    obj[index].balanceAmt = val ? parseFloat(val) : 0;
    setReportQtrDetailList({ ...obj });
    const updateTabs = localStore;
    if (
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.filter((x) => {
        return x.navTo === '/initCorrectCms64Report' && x.isFormSave;
      }).length > 0
    ) {
      const newObj = updateTabs.filter(
        (item) => item.navTo !== '/initCorrectCms64Report'
      );
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
      history.push({
        pathname: newObj.length > 0 ? newObj[0].navTo : '/dashboard',
      });
    }
    setStateChange('edit', true);
  }

  const saveAndCloseTab = () => {
    saveQtr(true);
  };

  const saveQtr = async (willCloseTab = false) => {
    setSuccessMessages([]);
    const data = [];
    let obj = {};
    let i = 1;
    await _.forEach(reportQtrDetailList, (row) => {
      let qtr = null;
      if (i == 5) {
        qtr = previousQtr[11];
      } else if (i == 4) {
        qtr = previousQtr[12];
      } else if (i == 3) {
        qtr = previousQtr[13];
      } else if (i == 2) {
        qtr = previousQtr[14];
      } else if (i == 1) {
        qtr = '0Q0000';
      }
      i++;
      obj = {
        rptQtr: headerList.rptQtr,
        qtr: qtr,
        rebateProgramCd: rebateProgramCd(),
        balanceAmt: row.balanceAmt,
      };
      data.push(obj);
    });
    await dispatch(saveCmsQtrReport(data));
    await setDisableBtn(true);
    await dispatch(
      updateReportQuarter({ reportQtrDetailList: { ...reportQtrDetailList } })
    );
    setStateChange('edit', false);
    if (willCloseTab) {
      closeTab('/initCorrectCms64Report', history);
    }
    setOpen(false);
  };

  function onBlur(event) {
    const { value } = event.target;
    const formattedValue = value.includes('-')
      ? `(${value.replace('-', '').trim()})`
      : value;
    // Handle the formattedValue or perform any logic you need here
  }

  // Function for onFocus event
  function onFocus(event) {
    let { value } = event.target;
    if (value.charAt(0) === '(' && value.charAt(value.length - 1) === ')') {
      value = value.substring(1, value.length - 1).replace('$', '');
      event.target.value = value;
    }
  }

  return (
    <div
      className=" tabs-container tBillPanel custom-check"
      data-testid="request-current-dispute-display"
    >
      <Spinner />
      <SaveCancelPopup
        open={open}
        title="Save"
        onConfim={() => {
          saveQtr();
        }}
        onCancel={() => {
          setOpen(false);
        }}
      />

      <SaveCancelPopup
        open={openCancel}
        title="Cancel"
        onConfim={() => {
          resetForm();
        }}
        onCancel={() => {
          setOpenCancel(false);
        }}
      />
      <CustomSeparator parent1="System" parent2="Init Correct CMS64 Report" />
      {saveCmsmesage && saveCmsmesage.length > 0 ? (
        <DisplaySuccessMessages successMessages={[SUCCESSMESSAGE_GENERIC]} />
      ) : (
        []
      )}
      {!fullScreenView && (
        <>
          <h6 className="text-center mb-3 mt-2">
            MEDICAID DRUG REBATE SCHEDULE
          </h6>
          <div className="row ">
            <div className="col-4 form-wrapper input-md mui-custom-form">
              <TextField
                data-testid="-textField"
                id="rptQtr-id"
                label="Calendar/Report Quarter"
                fullWidth
                disabled
                placeholder=""
                value={reportQuarter()}
                inputProps={{ maxLength: 38, id: 'rptQtr-id' }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </div>
            <div className="col-4 form-wrapper input-md mui-custom-form">
              <TextField
                data-testid="rebate-program-textField"
                id="rebate-program-id"
                label={
                  detailScreenObj?.selectBy === 'single'
                    ? 'Rebate Program'
                    : 'Group'
                }
                fullWidth
                disabled
                placeholder=""
                value={
                  detailScreenObj?.selectBy === 'single'
                    ? detailScreenObj?.rebateProgramCd
                    : detailScreenObj?.cmsReportingGrps
                }
                inputProps={{ maxLength: 38, id: 'rebate-program-id' }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </div>
          </div>
          <div className="row form-wrapper">
            <div className="col-4 input-md mui-custom-form">
              <TextField
                data-testid="state-textField"
                id="state-id"
                label="State"
                fullWidth
                disabled
                placeholder=""
                value={headerList.shortDescription || ''}
                inputProps={{ maxLength: 38, id: 'state-id' }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </div>
            <div className="col-4 input-md mui-custom-form">
              <TextField
                data-testid="Agency-textField"
                id="Agency-id"
                label="Agency"
                fullWidth
                disabled
                placeholder=""
                value={headerList.cms64AgencyName || ''}
                inputProps={{ maxLength: 38, id: 'Agency-id' }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </div>
            <div className="col-4 input-md mui-custom-form">
              <TextField
                data-testid="quarter-ended-textField"
                id="quarter-ended-id"
                label="Quarter Ended"
                fullWidth
                disabled
                placeholder=""
                value={previousQtr[6] ? previousQtr[6] : ''}
                inputProps={{ maxLength: 38, id: 'quarter-ended-id' }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </div>
          </div>
          <div className="row">
            <div className="col-3">
              <div className="mui-custom-form with-select input-md d-flex flex-column mt-1 mb-1">
                <TextField
                  data-testid="quarter-ending-a-textField"
                  id="quarter-ending-a-id"
                  label="Quarter Ending Date"
                  fullWidth
                  disabled
                  placeholder=""
                  value={previousQtr[6] ? previousQtr[6] : ''}
                  inputProps={{ maxLength: 38, id: 'quarter-ending-a-id' }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </div>
            </div>
            <div className="col-3">
              <div className="mui-custom-form with-select input-md d-flex flex-column mt-1 mb-1">
                <label
                  className="m-0 visually-hidden"
                  htmlFor="quarter-ending-b-id"
                >
                  <span>label</span>{' '}
                </label>
                <TextField
                  data-testid="quarter-ending-b-textField"
                  id="quarter-ending-b-id"
                  label=""
                  fullWidth
                  disabled
                  placeholder=""
                  value={previousQtr[7] ? previousQtr[7] : ''}
                  inputProps={{
                    maxLength: 38,
                    id: 'quarter-ending-b-id',
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  aria-label="quarter-ending-b-id"
                />
              </div>
            </div>
            <div className="col-3">
              <div className="mui-custom-form with-select input-md d-flex flex-column mt-1 mb-1">
                <label
                  className="m-0 visually-hidden"
                  htmlFor="quarter-ending-c-id"
                >
                  <span>label</span>{' '}
                </label>
                <TextField
                  data-testid="quarter-ending-c-textField"
                  id="quarter-ending-c-id"
                  label=""
                  fullWidth
                  disabled
                  placeholder=""
                  value={previousQtr[8] ? previousQtr[8] : ''}
                  inputProps={{ maxLength: 38, id: 'quarter-ending-c-id' }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  aria-label="quarter-ending-c-id"
                />
              </div>
            </div>
            <div className="col-3">
              <div className="mui-custom-form with-select input-md d-flex flex-column mt-1 mb-1">
                <label
                  className="m-0 visually-hidden"
                  htmlFor="quarter-ending-d-id"
                >
                  <span>label</span>{' '}
                </label>
                <TextField
                  data-testid="quarter-ending-d-textField"
                  id="quarter-ending-d-id"
                  label=""
                  fullWidth
                  disabled
                  placeholder=""
                  value={previousQtr[9] ? previousQtr[9] : ''}
                  inputProps={{ maxLength: 38, id: 'quarter-ending-d-id' }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  aria-label="quarter-ending-d-id"
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-3">
              <div className="mui-custom-form with-select input-md d-flex flex-column mt-1 mb-1">
                <TextField
                  data-testid="calendar-quarter-a-textField"
                  id="calendar-quarter-a-id"
                  label="Calendar Quarter"
                  fullWidth
                  disabled
                  placeholder=""
                  value={previousQtr[1] ? previousQtr[1] : ''}
                  inputProps={{ maxLength: 38, id: 'calendar-quarter-a-id' }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </div>
            </div>
            <div className="col-3">
              <div className="mui-custom-form with-select input-md d-flex flex-column mt-1 mb-1">
                <label
                  className="m-0 visually-hidden"
                  htmlFor="calendar-quarter-b-id"
                >
                  <span>label</span>{' '}
                </label>
                <TextField
                  data-testid="calendar-quarter-b-textField"
                  id="calendar-quarter-b-id"
                  label=""
                  fullWidth
                  disabled
                  placeholder=""
                  value={previousQtr[2] ? previousQtr[2] : ''}
                  inputProps={{ maxLength: 38, id: 'calendar-quarter-b-id' }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  aria-label="calendar-quarter-b-id"
                />
              </div>
            </div>
            <div className="col-3">
              <div className="mui-custom-form with-select input-md d-flex flex-column mt-1 mb-1">
                <label
                  className="m-0 visually-hidden"
                  htmlFor="calendar-quarter-c-id"
                >
                  <span>label</span>{' '}
                </label>
                <TextField
                  data-testid="calendar-quarter-c-textField"
                  id="calendar-quarter-c-id"
                  label=""
                  fullWidth
                  disabled
                  placeholder=""
                  value={previousQtr[3] ? previousQtr[3] : ''}
                  inputProps={{ maxLength: 38, id: 'calendar-quarter-c-id' }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  aria-label="calendar-quarter-c-id"
                />
              </div>
            </div>
            <div className="col-3">
              <div className="mui-custom-form with-select input-md d-flex flex-column mt-1 mb-1">
                <label
                  className="m-0 visually-hidden"
                  htmlFor="calendar-quarter-d-id"
                >
                  <span>label</span>{' '}
                </label>
                <TextField
                  data-testid="calendar-quarter-d-textField"
                  id="calendar-quarter-d-id"
                  label=""
                  fullWidth
                  disabled
                  placeholder=""
                  value={previousQtr[4] ? previousQtr[4] : ''}
                  inputProps={{ maxLength: 38, id: 'calendar-quarter-d-id' }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  aria-label="calendar-quarter-d-id"
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-3">
              <div className="mui-custom-form with-select input-md d-flex flex-column mt-1 mb-1">
                <TextField
                  data-testid="drug-rebate-quarter-a-textField"
                  id="drug-rebate-quarter-a-id"
                  label="Drug Rebate Quarter"
                  fullWidth
                  disabled
                  placeholder=""
                  value={previousQtr[11] ? previousQtr[11] : ''}
                  inputProps={{
                    maxLength: 38,
                    id: 'drug-rebate-quarter-a-id',
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </div>
            </div>
            <div className="col-3">
              <div className="mui-custom-form with-select input-md d-flex flex-column mt-1 mb-1">
                <label
                  className="m-0 visually-hidden"
                  htmlFor="drug-rebate-quarter-b-id"
                >
                  <span>label</span>{' '}
                </label>
                <TextField
                  data-testid="drug-rebate-quarter-b-textField"
                  id="drug-rebate-quarter-b-id"
                  label=""
                  fullWidth
                  disabled
                  placeholder=""
                  value={previousQtr[12] ? previousQtr[12] : ''}
                  inputProps={{
                    maxLength: 38,
                    id: 'drug-rebate-quarter-b-id',
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  aria-label="drug-rebate-quarter-b-id"
                />
              </div>
            </div>
            <div className="col-3">
              <div className="mui-custom-form with-select input-md d-flex flex-column mt-1 mb-1">
                <label
                  className="m-0 visually-hidden"
                  htmlFor="drug-rebate-quarter-c-id"
                >
                  <span>label</span>{' '}
                </label>
                <TextField
                  data-testid="drug-rebate-quarter-c-textField"
                  id="drug-rebate-quarter-c-id"
                  label=""
                  fullWidth
                  disabled
                  placeholder=""
                  value={previousQtr[13] ? previousQtr[13] : ''}
                  inputProps={{
                    maxLength: 38,
                    id: 'drug-rebate-quarter-c-id',
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  aria-label="drug-rebate-quarter-b-id"
                />
              </div>
            </div>
            <div className="col-3">
              <div className="mui-custom-form with-select input-md d-flex flex-column mt-1 mb-1">
                <label
                  className="m-0 visually-hidden"
                  htmlFor="drug-rebate-quarter-d-id"
                >
                  <span>label</span>{' '}
                </label>
                <TextField
                  data-testid="drug-rebate-quarter-d-textField"
                  id="drug-rebate-quarter-d-id"
                  label=""
                  fullWidth
                  disabled
                  placeholder=""
                  value={previousQtr[14] ? previousQtr[14] : ''}
                  inputProps={{
                    maxLength: 38,
                    id: 'drug-rebate-quarter-d-id',
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  aria-label="drug-rebate-quarter-b-id"
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-3">
              <div className="mui-custom-form with-select input-md d-flex flex-column mt-1 mb-1">
                <TextField
                  data-testid="quarter-balance-a-textField"
                  id="quarter-balance-a-id"
                  label="End of Quarter Balance"
                  fullWidth
                  placeholder=""
                  value={
                    geBalance(4) < 0 && inputField.input4 == false
                      ? '($ ' + Math.abs(geBalance(4)) + ')'
                      : inputField.input4 == false
                      ? '$' + geBalance(4)
                      : geBalance(4)
                  }
                  inputProps={{
                    maxLength: 38,
                    style: {
                      flexDirection: 'row-reverse',
                      textAlign: 'right',
                      color: geBalance(4) < 0 ? '#DC143C' : '#000',
                    },
                    startAdornment: geBalance(4) && (
                      <InputAdornment position="start">$</InputAdornment>
                    ),
                  }}
                  onBlur={() => setInputField({ ...inputField, input4: false })}
                  onFocus={() => setInputField({ ...inputField, input4: true })}
                  style={{ flexDirection: 'row-reverse' }}
                  onChange={(e) => updatePreviousQtr(e, 4)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  // InputProps={{
                  //   inputComponent: (cellInfo) => forNegativeValues(cellInfo),
                  // }}
                />
              </div>
            </div>
            <div className="col-3">
              <div className="mui-custom-form with-select input-md d-flex flex-column mt-1 mb-1">
                <label
                  className="m-0 visually-hidden"
                  htmlFor="quarter-balance-b-id"
                >
                  <span>label</span>{' '}
                </label>
                <TextField
                  data-testid="quarter-balance-b-textField"
                  id="quarter-balance-b-id"
                  label=""
                  fullWidth
                  placeholder=""
                  value={
                    geBalance(3) < 0 && inputField.input4 == false
                      ? '($ ' + Math.abs(geBalance(3)) + ')'
                      : inputField.input3 == false
                      ? '$' + geBalance(3)
                      : geBalance(3)
                  }
                  inputProps={{
                    maxLength: 38,
                    style: {
                      flexDirection: 'row-reverse',
                      textAlign: 'right',
                      color: geBalance(3) < 0 ? '#DC143C' : '#000',
                    },
                    startAdornment: geBalance(3) && (
                      <InputAdornment position="start">$</InputAdornment>
                    ),
                  }}
                  onBlur={() => setInputField({ ...inputField, input3: false })}
                  onFocus={() => setInputField({ ...inputField, input3: true })}
                  style={{ flexDirection: 'row-reverse' }}
                  onChange={(e) => updatePreviousQtr(e, 3)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  aria-label="quarter-balance-b-id"
                />
              </div>
            </div>
            <div className="col-3">
              <div className="mui-custom-form with-select input-md d-flex flex-column mt-1 mb-1">
                <label
                  className="m-0 visually-hidden"
                  htmlFor="quarter-balance-c-id"
                >
                  <span>label</span>{' '}
                </label>
                <TextField
                  data-testid="quarter-balance-c-textField"
                  id="quarter-balance-c-id"
                  label=""
                  fullWidth
                  placeholder=""
                  value={
                    geBalance(2) < 0 && inputField.input4 == false
                      ? '($ ' + Math.abs(geBalance(2)) + ')'
                      : inputField.input2 == false
                      ? '$' + geBalance(2)
                      : geBalance(2)
                  }
                  inputProps={{
                    maxLength: 38,
                    style: {
                      flexDirection: 'row-reverse',
                      textAlign: 'right',
                      color: geBalance(2) < 0 ? '#DC143C' : '#000',
                    },
                    startAdornment: geBalance(2) && (
                      <InputAdornment position="start">$</InputAdornment>
                    ),
                  }}
                  onBlur={() => setInputField({ ...inputField, input2: false })}
                  onFocus={() => setInputField({ ...inputField, input2: true })}
                  style={{ flexDirection: 'row-reverse' }}
                  onChange={(e) => updatePreviousQtr(e, 2)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  aria-label="quarter-balance-c-id"
                />
              </div>
            </div>
            <div className="col-3">
              <div className="mui-custom-form with-select input-md d-flex flex-column mt-1 mb-1">
                <label
                  className="m-0 visually-hidden"
                  htmlFor="quarter-balance-d-id"
                >
                  <span>label</span>{' '}
                </label>
                <TextField
                  data-testid="quarter-balance-d-textField"
                  id="quarter-balance-d-id"
                  label=""
                  fullWidth
                  placeholder=""
                  value={
                    geBalance(1) < 0 && inputField.input1 == false
                      ? '($ ' + Math.abs(geBalance(1)) + ')'
                      : inputField.input1 == false
                      ? '$' + geBalance(1)
                      : geBalance(1)
                  }
                  inputProps={{
                    maxLength: 38,
                    style: {
                      flexDirection: 'row-reverse',
                      textAlign: 'right',
                      color: geBalance(1) < 0 ? '#DC143C' : '#000',
                    },
                    startAdornment: geBalance(1) && (
                      <InputAdornment position="start">$</InputAdornment>
                    ),
                  }}
                  onBlur={() => setInputField({ ...inputField, input1: false })}
                  onFocus={() => setInputField({ ...inputField, input1: true })}
                  style={{ flexDirection: 'row-reverse' }}
                  onChange={(e) => updatePreviousQtr(e, 1)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  aria-label="quarter-balance-d-id"
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-3">
              <div className="mui-custom-form with-select input-md d-flex flex-column">
                <TextField
                  data-testid="previous-quarters-textField"
                  id="previous-quarters-id"
                  label="Previous Quaters"
                  fullWidth
                  placeholder=""
                  value={
                    geBalance(0) < 0 && inputField.input0 == false
                      ? '($ ' + Math.abs(geBalance(0)) + ')'
                      : inputField.input0 == false
                      ? '$' + geBalance(0)
                      : geBalance(0)
                  }
                  inputProps={{
                    maxLength: 38,
                    style: {
                      flexDirection: 'row-reverse',
                      textAlign: 'right',
                      color: geBalance(0) < 0 ? '#DC143C' : '#000',
                    },
                    startAdornment: geBalance(0) && (
                      <InputAdornment position="start">$</InputAdornment>
                    ),
                  }}
                  onBlur={() => setInputField({ ...inputField, input0: false })}
                  onFocus={() => setInputField({ ...inputField, input0: true })}
                  style={{ flexDirection: 'row-reverse' }}
                  onChange={(e) => updatePreviousQtr(e, 0)}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </div>
            </div>
            <div className="col-3">
              <div className="mui-custom-form with-select input-md d-flex flex-column">
                <TextField
                  data-testid="final-totals-textField"
                  id="final-totals-id"
                  label="Final Totals"
                  disabled
                  fullWidth
                  placeholder=""
                  value={geBalance()}
                  inputProps={{
                    maxLength: 38,
                    id: 'final-totals-id',
                  }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    inputComponent: (cellInfo) => forNegativeValues(cellInfo),
                  }}
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <div className="float-right mb-3">
                <div className="btn-wrapper mt-3">
                  <Button
                    className="btn btn-success btn-search"
                    onClick={openSave}
                    data-testid="openSave"
                    disabled={disableBtn}
                  >
                    <SVGComponent iconName="Icon-awesome-save" /> Save
                  </Button>
                  <Button
                    className="btn btn-cancel"
                    onClick={() => setOpenCancel(true)}
                    disabled={disableBtn}
                  >
                    <SVGComponent iconName="Icon-cancel" /> Cancel
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
export default InitCorrectCmsReport;
